import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Please add new comment", -1 /* HOISTED */)
const _hoisted_2 = { class: "column label" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" * Choose a date and time for the comment ")
const _hoisted_4 = { class: "row justify-left q-mt-md" }
const _hoisted_5 = { class: "datepicker-input" }
const _hoisted_6 = { class: "row items-center justify-end" }
const _hoisted_7 = { class: "row items-center justify-end" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" * Information type ")
const _hoisted_10 = { class: "row analysis-data" }
const _hoisted_11 = { class: "label auto-size-kpi" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Analysis type ")
const _hoisted_13 = { class: "label auto-size-kpi" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Oil type ")
const _hoisted_15 = {
  key: 0,
  class: "label auto-size-kpi"
}
const _hoisted_16 = { class: "label auto-size-kpi status-selector" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" * Quality KPI ")
const _hoisted_18 = {
  key: 1,
  class: "col-12"
}
const _hoisted_19 = { class: "col-4 q-pl-none q-pt-1" }
const _hoisted_20 = { class: "label auto-size-kpi" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Analysis type ")
const _hoisted_22 = { class: "col-4 q-pt-1" }
const _hoisted_23 = { class: "label auto-size-kpi" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Equipments ")
const _hoisted_25 = { class: "col-3 q-pt-1" }
const _hoisted_26 = { class: "label auto-size-kpi status-selector" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" * Quality KPI ")
const _hoisted_28 = { class: "col-1 q-pt-1 flex justify-end" }
const _hoisted_29 = { class: "label column q-mb-md" }
const _hoisted_30 = { class: "label column q-mb-md" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Comment files ")
const _hoisted_32 = { class: "label column q-mb-md" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" WO number ")
const _hoisted_34 = { class: "q-mb-md" }
const _hoisted_35 = { class: "label column q-mb-md" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Author ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_ElecAnalysis = _resolveComponent("ElecAnalysis")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.getDisplayAddCommentPopin,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.getDisplayAddCommentPopin) = $event)),
      "data-test": "add-comment-popin",
      style: {"width":"500px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "q-pa-md",
          style: {"width":"750px","overflow":"scroll","max-width":"100vw"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_q_space),
                _createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: "",
                  "data-test": "button-close",
                  onClick: _ctx.onClose
                }, null, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("form", {
                  class: "column",
                  onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.selectedDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDate) = $event)),
                          rules: [_ctx.isValidDate],
                          outlined: "",
                          dense: ""
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "event",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      modelValue: _ctx.selectedDate,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDate) = $event)),
                                      mask: "YYYY-MM-DD HH:mm",
                                      options: _ctx.minDate,
                                      bordered: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _withDirectives(_createVNode(_component_q_btn, {
                                            label: "Close",
                                            color: "primary",
                                            flat: ""
                                          }, null, 512 /* NEED_PATCH */), [
                                            [_directive_close_popup]
                                          ])
                                        ])
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "access_time",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_time, {
                                      modelValue: _ctx.selectedDate,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                                      mask: "YYYY-MM-DD HH:mm",
                                      options: _ctx.minTime,
                                      format24h: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, [
                                          _withDirectives(_createVNode(_component_q_btn, {
                                            label: "Close",
                                            color: "primary",
                                            flat: ""
                                          }, null, 512 /* NEED_PATCH */), [
                                            [_directive_close_popup]
                                          ])
                                        ])
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "rules"])
                      ])
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.selectedInformationType,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedInformationType) = $event)),
                      options: 
                  _ctx.getEquipmentDetails?.equipmentModel?.system ===
                  _ctx.equipmentSystemEnum.TRANSFORMERS
                    ? _ctx.informationTypesTransformers
                    : _ctx.getEquipmentDetails?.driven === 'Pump'
                    ? _ctx.informationTypesForDrivenPUMP
                    : _ctx.getEquipmentDetails?.driven === 'Compressor'
                    ? _ctx.informationTypesForDrivenCOMP
                    : _ctx.informationTypes
                ,
                      "option-label": "label",
                      "option-value": "value",
                      standout: "",
                      "map-options": "",
                      "emit-value": "",
                      "bottom-slots": "",
                      class: "q-mt-md main-dropdown-100",
                      "bg-color": "white",
                      borderless: "",
                      "input-style": {
                  fontFamily: 'Roboto',
                  fontSize: '12px',
                  lineHeight: '16px',
                },
                      outlined: "",
                      dense: ""
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.analysisType,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.analysisType) = $event)),
                        options: _ctx.analysisTypes,
                        "option-label": "label",
                        "option-value": "value",
                        standout: "",
                        "map-options": "",
                        "emit-value": "",
                        "bottom-slots": "",
                        class: "q-mt-md q-pr-md main-dropdown-100",
                        "bg-color": "white",
                        borderless: "",
                        "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                        outlined: "",
                        dense: ""
                      }, null, 8 /* PROPS */, ["modelValue", "options"])
                    ]),
                    _withDirectives(_createElementVNode("span", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.oilType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.oilType) = $event)),
                        options: _ctx.oilTypes,
                        "option-label": "label",
                        "option-value": "value",
                        standout: "",
                        "map-options": "",
                        "emit-value": "",
                        "bottom-slots": "",
                        class: "q-mt-md q-pr-md main-dropdown-100",
                        "bg-color": "white",
                        borderless: "",
                        "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                        outlined: "",
                        dense: ""
                      }, null, 8 /* PROPS */, ["modelValue", "options"])
                    ], 512 /* NEED_PATCH */), [
                      [_vShow, 
                  _ctx.selectedInformationType === _ctx.informationTypeEnum.OIL &&
                  _ctx.getEquipmentDetails?.equipmentModel?.system !==
                    _ctx.equipmentSystemEnum.TRANSFORMERS
                ]
                    ]),
                    (
                  _ctx.getEquipmentDetails.driven === 'Compressor' ||
                  _ctx.getEquipmentDetails.driven === 'Pump'
                )
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_15, [
                          _createTextVNode(_toDisplayString(_ctx.getDryGasSealLabel()) + " ", 1 /* TEXT */),
                          (_ctx.getDryGasSealLabel() === 'Dry gas seal type')
                            ? (_openBlock(), _createBlock(_component_q_select, {
                                key: 0,
                                modelValue: _ctx.dryGasSealType,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dryGasSealType) = $event)),
                                options: _ctx.dryGasSealTypes,
                                "option-label": "label",
                                "option-value": "value",
                                standout: "",
                                "map-options": "",
                                "emit-value": "",
                                "bottom-slots": "",
                                class: "q-mt-md q-pr-md main-dropdown-100",
                                "bg-color": "white",
                                borderless: "",
                                "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                                outlined: "",
                                dense: ""
                              }, null, 8 /* PROPS */, ["modelValue", "options"]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.getDryGasSealLabel() === 'Mechanical seal type')
                            ? (_openBlock(), _createBlock(_component_q_select, {
                                key: 1,
                                modelValue: _ctx.dryGasSealType,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dryGasSealType) = $event)),
                                options: _ctx.dryGasSealTypesForDrivenPUMP,
                                "option-label": "label",
                                "option-value": "value",
                                standout: "",
                                "map-options": "",
                                "emit-value": "",
                                "bottom-slots": "",
                                class: "q-mt-md q-pr-md main-dropdown-100",
                                "bg-color": "white",
                                borderless: "",
                                "input-style": {
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    lineHeight: '16px',
                  },
                                outlined: "",
                                dense: ""
                              }, null, 8 /* PROPS */, ["modelValue", "options"]))
                            : _createCommentVNode("v-if", true)
                        ], 512 /* NEED_PATCH */)), [
                          [_vShow, 
                  _ctx.selectedInformationType === _ctx.informationTypeEnum.DRY_GAS_SEAL
                ]
                        ])
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.qualityKpi,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.qualityKpi) = $event)),
                        options: _ctx.qualityKpis,
                        "option-label": "label",
                        "option-value": "value",
                        outlined: "",
                        standout: "",
                        "map-options": "",
                        "emit-value": "",
                        "bottom-slots": "",
                        class: _normalizeClass(_ctx.getClassQuality),
                        rules: [
                    (val) => val !== undefined || 'Please select Quality KPI',
                  ],
                        "lazy-rules": "",
                        dense: ""
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            class: _normalizeClass(_ctx.getClassQualityIcon),
                            name: _ctx.icon,
                            style: {"font-size":"14px"}
                          }, null, 8 /* PROPS */, ["class", "name"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "options", "class", "rules"])
                    ]),
                    (
                  _ctx.getEquipmentDetails?.equipmentModel?.system ===
                    _ctx.equipmentSystemEnum.TRANSFORMERS &&
                  (_ctx.selectedInformationType === _ctx.informationTypeEnum.OIL ||
                    _ctx.selectedInformationType === _ctx.informationTypeEnum.INSULATION)
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_ElecAnalysis, {
                            "oil-analysis": _ctx.oilAnalysis,
                            "insulation-analysis": _ctx.insulationAnalysis,
                            "information-type": _ctx.selectedInformationType
                          }, null, 8 /* PROPS */, ["oil-analysis", "insulation-analysis", "information-type"])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 512 /* NEED_PATCH */), [
                    [_vShow, 
                _ctx.selectedInformationType !== _ctx.informationTypeEnum.OTHER &&
                _ctx.selectedInformationType !==
                  _ctx.informationTypeEnum.SERVICE_BULLETINS &&
                _ctx.selectedInformationType !== _ctx.informationTypeEnum.VIBRATION
              ]
                  ]),
                  (_ctx.selectedInformationType === _ctx.informationTypeEnum.VIBRATION)
                    ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vibrationRows, (row, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "row q-col-gutter-md items-center q-mb-sm analysis-data"
                            }, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, [
                                  _hoisted_21,
                                  _createVNode(_component_q_select, {
                                    modelValue: row.analysisType,
                                    "onUpdate:modelValue": ($event: any) => ((row.analysisType) = $event),
                                    options: _ctx.analysisTypes,
                                    "option-label": "label",
                                    "option-value": "value",
                                    standout: "",
                                    "map-options": "",
                                    "emit-value": "",
                                    "bottom-slots": "",
                                    class: "q-mt-md q-pr-md main-dropdown-100",
                                    "bg-color": "white",
                                    borderless: "",
                                    "input-style": {
                        fontFamily: 'Roboto',
                        fontSize: '12px',
                        lineHeight: '16px',
                      },
                                    outlined: ""
                                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, [
                                  _hoisted_24,
                                  _createVNode(_component_q_select, {
                                    modelValue: row.equipmentType,
                                    "onUpdate:modelValue": ($event: any) => ((row.equipmentType) = $event),
                                    options: _ctx.equipmentTypes,
                                    "option-label": "label",
                                    "option-value": "value",
                                    standout: "",
                                    "map-options": "",
                                    "emit-value": "",
                                    "bottom-slots": "",
                                    class: "q-mt-md q-pr-md main-dropdown-100",
                                    "bg-color": "white",
                                    borderless: "",
                                    "input-style": {
                        fontFamily: 'Roboto',
                        fontSize: '12px',
                        lineHeight: '16px',
                      },
                                    outlined: ""
                                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, [
                                  _hoisted_27,
                                  _createVNode(_component_q_select, {
                                    modelValue: row.qualityKpi,
                                    "onUpdate:modelValue": ($event: any) => ((row.qualityKpi) = $event),
                                    options: _ctx.qualityKpis,
                                    "option-label": "label",
                                    "option-value": "value",
                                    outlined: "",
                                    standout: "",
                                    "map-options": "",
                                    "emit-value": "",
                                    "bottom-slots": "",
                                    class: _normalizeClass(_ctx.getClassQuality),
                                    rules: [
                        (val) =>
                          val !== undefined || 'Please select Quality KPI',
                      ],
                                    "lazy-rules": ""
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        class: _normalizeClass(_ctx.getClassQualityIcon),
                                        name: _ctx.icon,
                                        style: {"font-size":"14px"}
                                      }, null, 8 /* PROPS */, ["class", "name"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options", "class", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_q_btn, {
                                  dense: "",
                                  round: "",
                                  icon: "add",
                                  color: "primary",
                                  onClick: _ctx.addRow
                                }, null, 8 /* PROPS */, ["onClick"])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", _hoisted_29, [
                    _createTextVNode(_toDisplayString(_ctx.getEquipmentDetails?.equipmentModel?.system !==
                _ctx.equipmentSystemEnum.TRANSFORMERS
                  ? "*"
                  : "") + " Event comment ", 1 /* TEXT */),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.comment,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.comment) = $event)),
                      type: "textarea",
                      rows: "3",
                      outlined: "",
                      required: 
                  _ctx.getEquipmentDetails?.equipmentModel?.system !==
                  _ctx.equipmentSystemEnum.TRANSFORMERS
                
                    }, null, 8 /* PROPS */, ["modelValue", "required"])
                  ]),
                  _createElementVNode("span", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_q_file, {
                      modelValue: _ctx.files,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.files) = $event)),
                      label: "Select files",
                      multiple: "",
                      append: "",
                      "use-chips": "",
                      outlined: "",
                      class: "file-upload",
                      dense: ""
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, { name: "cloud_upload" })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("span", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.woNumber,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.woNumber) = $event)),
                      maxlength: "10",
                      outlined: "",
                      dense: "",
                      onKeypress: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isNumberCheck($event)))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_checkbox, {
                      modelValue: _ctx.addToWeeklyReport,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addToWeeklyReport) = $event)),
                      label: "Add to weekly report ?"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_q_checkbox, {
                      modelValue: _ctx.isAlert,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isAlert) = $event)),
                      label: "Display alert ?"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("span", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", null, _toDisplayString(_ctx.author), 1 /* TEXT */)
                  ]),
                  _createVNode(_component_q_card_actions, { align: "right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        outline: "",
                        rounded: "",
                        "no-caps": "",
                        class: "action-button",
                        type: "submit",
                        label: "Add comment"
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ], 32 /* HYDRATE_EVENTS */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}